//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import { openDB } from "idb";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      appUserId: "",
      formValid: true,
      progressStatus: false,
      customErrorMsg: "",
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  methods: {
    ...mapMutations(["setCrfTitle"]),
    async userLogin() {
      if (!this.formValid) {
        return;
      }
      const actionUrl = `${process.env.BASE_URL}AppAuth/AuthenticateUserId`;
      this.progressStatus = true;
      try {
        const {
          data: { rstatus, rdata },
        } = await axios.get(actionUrl, {
          params: { appUserId: this.appUserId },
        });
        if (rstatus == 0) {
          //save data to local idb
          const db = await openDB("AIRWAYS3idb");
          const tx = db.transaction("tbSettings", "readwrite");
          const store = tx.objectStore("tbSettings");
          await store.put(this.appUserId, "pin");
          await store.put(rdata, "sites");
          await store.put(rdata[0].value, "defaultSite");
          await store.put({ state: 0, lastSyncDate: null }, "syncSatus");
          await tx.done;
          this.$router.push("/");
        } else if (rstatus == -2) {
          this.customErrorMsg =
            "Sorry, we have noticed an issue with your account setup, please contact the Trial Team.";
        }
        this.progressStatus = false;
      } catch (error) {
        this.customErrorMsg =
          "Please make sure the information you are entering is correct.";
        this.progressStatus = false;
      }
    },
  },
  mounted() {
    this.setCrfTitle("Activate Profile");
  },
};
